import React from "react";

import cx from "classnames";

import styles from "./Heading.scss";

type HeadingLevel = "1" | "2" | "3" | "4" | "5" | "6";
type HeadingTag = `h${HeadingLevel}`;
type HeadingElement = HTMLHeadingElement;

export interface HeadingProps
  extends Omit<React.HTMLAttributes<HeadingElement>, "aria-level"> {
  /**
   * What heading level (1-6) do you want?
   */
  level?: HeadingLevel;
  /**
   * Content that should be rendered by the heading
   */
  children: React.ReactNode;
}

/**
 * Renders a heading element with proper semantic markup
 */
export function Heading({
  level = "1",
  children,
  className,
  ...props
}: HeadingProps): JSX.Element {
  const Tag: HeadingTag = `h${level}`;
  const classNames = cx(styles[Tag], className);

  return (
    <Tag {...props} className={classNames} aria-level={Number(level)}>
      {children}
    </Tag>
  );
}
